// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__9e6oh","content":"default_content__vKz3l","column":"default_column__aJzAJ"};